import TM from "@/api/ticket-management";

const getDefaultState = () => {
  return {
    pageData: null,
    isPopState: false,
    discounts: null,
    boughtTickets: [],
    selectedArea: null,
    areaAssignment: false,
    seatAssignment: false,
    counterInterval: null,
    timer: 900, // 倒數計時計
    reserveResponse: {},
    updateResponse: {},
    currentOrder: null,
    currentReserved: null,
    orderComplete: 0
  };
};

//init state
const state = getDefaultState();

const mutations = {
  SET_SELECTEDAREA: (state, area) => {
    state.selectedArea = area;
  },
  SET_TICKETS: (state, tickets) => {
    state.boughtTickets = tickets;
  },
  SET_AREAASSIGNMENT: (state, bool) => {
    state.areaAssignment = bool;
  },
  SET_SEATASSIGNMENT: (state, bool) => {
    state.seatAssignment = bool;
  },
  SET_DISCOUNT: (state, discounts) => {
    state.discounts = discounts;
  },
  SET_CURRENT_RESERVED: (state, currentReserved) => {
    state.currentReserved = currentReserved;
  },
  CURRENT_ORDER: (state, currentOrder) => {
    state.currentOrder = currentOrder;
  },
  COUNT_DOWN_TIMER: state => {
    if (
      !state.reserveResponse ||
      !state.reserveResponse.products ||
      !state.reserveResponse.products.length
    )
      return;
    let currTime = new Date();
    let expiredTime = new Date(
      state.reserveResponse.products[0].expiryTimestamp
    );
    state.timer = (new Date(expiredTime) - currTime) / 1000;
    if (state.timer) {
      if (state.timer <= 0) {
        state.timer = 0;
      }
      state.counterInterval = setInterval(() => {
        if (state.timer > 0) {
          let nowTime = new Date();
          state.timer = parseInt(
            (new Date(state.reserveResponse.products[0].expiryTimestamp) -
              nowTime) /
              1000
          );
        } else {
          clearInterval(state.counterInterval);
          state.timer = 0;
        }
      }, 1000);
    }
  },
  COUNT_TIMER: state => {
    let currTime = new Date();
    let expiredTime = new Date(
      state.reserveResponse.products[0].expiryTimestamp
    );
    state.timer = parseInt((expiredTime - currTime) / 1000);

    if (state.timer) {
      if (state.timer <= 0) {
        state.timer = 0;
      }
      state.counterInterval = setInterval(() => {
        if (state.timer > 0) {
          let nowTime = new Date();
          state.timer = parseInt(
            (state.reserveResponse.products[0].expiryTimestamp - nowTime) / 1000
          );
        } else {
          state.timer = 0;
        }
      }, 1000);
    }
  },
  GET_CURRENT_RESERVED_ORDER: (state, data) => {
    state.reserveResponse = {
      ...data.order
    };
  },
  SET_TICKET_RESERVE_RESPONSE: (state, reserveResponse) => {
    state.reserveResponse = reserveResponse;
  },
  SET_ORDER_UPDATE_RESPONSE: (state, updateResponse) => {
    state.updateResponse = updateResponse;
    let products = [];

    let tickets = updateResponse.products.reduce((accr, product, index) => {
      let prod = state.reserveResponse.products.find(
        p => p.productId === product.productId
      );

      delete prod.row;
      delete prod.column;
      delete prod.index;
      delete prod.nextIndex;
      products.push({
        ...prod,
        ...product
      });

      if (product.seats) {
        product.seats.forEach((seat, i) => {
          let val = {
            ...prod,
            ...seat,
            count: 1,
            applicants: product.applicants
          };
          if (product.culturePointProductInfos)
            val.culturePointProductInfos = product.culturePointProductInfos[i];
          accr.push(val);
        });
      } else {
        let val = {
          ...product,
          ...prod
        };
        if (product.culturePointProductInfos)
          val.culturePointProductInfos = {
            ...product.culturePointProductInfos[0],
            deductAmount: product.culturePointProductInfos.reduce(
              (accr, info) => {
                accr += info.deductAmount;
                return accr;
              },
              0
            )
          };
        accr.push(val);
      }
      return accr;
    }, []);
    if (updateResponse.products && updateResponse.products.length) {
      state.boughtTickets = tickets;
      state.reserveResponse = {
        ...state.reserveResponse,
        total: updateResponse.total,
        culturePointDeductAmount: updateResponse.culturePointDeductAmount,
        products,
        tickets
      };
    }
  },
  RESET: state => {
    // console.log("[vuex/order] RESET order state");
    clearInterval(state.counterInterval);
    localStorage.removeItem("orderExpired");
    Object.assign(state, getDefaultState());
  },
  POPSTATE: (state, popstate) => {
    // console.log("[vuex/order] RESET order state");
    state.isPopState = popstate;
  },
  PAGEDATA: (state, data) => {
    // console.log("[vuex/order] RESET order state");
    state.pageData = data;
  },
  SET_ORDERCOMPLETE: (state, data) => {
    // console.log("[vuex/order] RESET order state");
    state.orderComplete = data;
  }
};

const actions = {
  buyTickets({ commit }, tickets) {
    commit("SET_TICKETS", tickets);
  },
  setSelectedArea({ commit }, area) {
    commit("SET_SELECTEDAREA", area);
  },
  setAreaAssignment({ commit }, bool) {
    commit("SET_AREAASSIGNMENT", bool);
  },
  setSeatAssignment({ commit }, bool) {
    commit("SET_SEATASSIGNMENT", bool);
  },
  setDiscount({ commit }, discount) {
    commit("SET_DISCOUNT", discount);
  },
  countDownTimer({ commit }) {
    commit("COUNT_DOWN_TIMER");
  },
  setTimer({ commit }, timer) {
    commit("COUNT_DOWN_TIMER", timer || 15);
  },
  reserveTicket({ commit }, response) {
    commit("SET_TICKET_RESERVE_RESPONSE", response);
  },
  setCurrentReserved({ commit }, reserved) {
    commit("SET_CURRENT_RESERVED", reserved);
  },
  updateOrder({ commit }, response) {
    commit("SET_ORDER_UPDATE_RESPONSE", response);
  },
  resetOrderState({ commit }) {
    commit("RESET");
  },
  setPopState({ commit }, pop) {
    commit("POPSTATE", pop);
  },
  setPageData({ commit }, data) {
    commit("PAGEDATA", data);
  },
  setCurrentOrder({ commit }, order) {
    commit("CURRENT_ORDER", order);
  },
  async getCurrentReservedOrder({ commit }) {
    const { data } = await TM.getUserCurrentReservedOrder();
    commit("GET_CURRENT_RESERVED_ORDER", data.order ? data : null);
  },
  async setOrderComplete({ commit }, data) {
    commit("SET_ORDERCOMPLETE", data);
  }
};

const getters = {
  boughtTickets: state => state.boughtTickets,
  selectedArea: state => state.selectedArea,
  areaAssignment: state => state.areaAssignment,
  seatAssignment: state => state.seatAssignment,
  reserveResponse: state => state.reserveResponse,
  timer: state => state.timer,
  updateResponse: state => state.updateResponse,
  discounts: state => state.discounts,
  isPopState: state => state.isPopState,
  pageData: state => state.pageData,
  currentOrder: state => state.currentOrder,
  currentReserved: state => state.currentReserved,
  orderComplete: state => state.orderComplete
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
